import React, { useState } from "react";
import {
  EnvelopeIcon,
  MapPinIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import { FacebookIcon, MusicIcon } from "lucide-react";
import LogoSvg from "../../common/assets/images/logo2.svg";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    // Handle email submission
    setEmail("");
  };

  return (
    <footer className="bg-[#db3b6d] text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">LIÊN HỆ</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-2">
                <EnvelopeIcon className="w-5 h-5 mt-1 flex-shrink-0" />
                <span>dducpimax@gmail.com</span>
              </div>
              <div className="flex items-start space-x-2">
                <FacebookIcon className="w-5 h-5 mt-1 flex-shrink-0" />
                <a
                  href="https://www.facebook.com/dducpimax1994"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  facebook.com/dducpimax1994
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <MapPinIcon className="w-5 h-5 mt-1 flex-shrink-0" />
                <span>THỤY KHUÊ, HÀ NỘI</span>
              </div>
              <div className="flex items-start space-x-2">
                <PhoneIcon className="w-5 h-5 mt-1 flex-shrink-0" />
                <span>0358030143</span>
              </div>
            </div>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-xl font-bold mb-4">HỖ TRỢ</h3>
            <div className="space-y-2">
              <a href="#" className="block hover:underline">
                HƯỚNG DẪN THANH TOÁN
              </a>
              <a href="#" className="block hover:underline">
                ĐĂNG KÍ CỘNG TÁC VIÊN
              </a>
            </div>
          </div>

          {/* Email Registration */}
          <div>
            <h3 className="text-xl font-bold mb-4">ĐĂNG KÍ QUA EMAIL</h3>
            <form onSubmit={handleEmailSubmit} className="flex">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="NHẬP EMAIL"
                className="flex-1 px-4 py-2 rounded-l-lg text-gray-800 focus:outline-none"
                required
              />
              <button
                type="submit"
                className="bg-white text-[#db3b6d] px-4 py-2 rounded-r-lg hover:bg-gray-100 transition-colors"
              >
                <EnvelopeIcon className="w-6 h-6" />
              </button>
            </form>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-xl font-bold mb-4">MẠNG XÃ HỘI</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/dducpimax1994"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white rounded-lg flex items-center justify-center hover:bg-gray-100 transition-colors"
              >
                <FacebookIcon className="w-6 h-6 text-[#db3b6d]" />
              </a>
              <a
                href="https://www.tiktok.com/@pimaxghettoan"
                target="_blank"
                className="w-12 h-12 bg-white rounded-lg flex items-center justify-center hover:bg-gray-100 transition-colors"
                rel="noreferrer"
              >
                {/* <MusicIcon className="w-6 h-6 text-[#db3b6d]" /> */}
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#db3b6d"
                    d="M36.4 13.2c-2.6-.8-4.8-2.8-5.7-5.4-.3-.8-.5-1.7-.5-2.6h-6.1v25.2c0 3-2.4 5.4-5.4 5.4s-5.4-2.4-5.4-5.4 2.4-5.4 5.4-5.4c.6 0 1.2.1 1.7.3v-6.2c-.6-.1-1.1-.1-1.7-.1-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12V17.9c2.4 1.8 5.3 2.9 8.4 3v-7.7z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-white/20 text-center">
          <div className="flex items-center justify-center space-x-2">
            <div className="w-8 h-8 bg-[#db3b6d] rounded flex items-center justify-center">
              <img src={LogoSvg} alt="PIMAX" className="w-8 h-8" />
            </div>
            <span className="font-medium">BẢN QUYỀN THUỘC VỀ PIMAX</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
